<div class="loadingOverlay" *ngIf="isLoading">
  <img src="assets/images/loadinganim.gif">
</div>
<div #activeDraftElement><app-active-drafts2 *ngIf="!isMobile" style="margin-bottom:5px;"></app-active-drafts2></div>
<div class="leagueHeader" #leagueHeader> 
        <div class="body">
          <div class="leagueName">
            <div class="icon" [ngStyle]="{'background-repeat': 'no-repeat','background-image':'url(\''+bucketURL+rankemData?.league?.lg_abbr+'_icon'+darkMode_ext+'.svg\')'}"></div>
            <span>{{rankemData?.league?.name}} | </span>
            <span class="status">{{rankemData?.league.status}}</span>
          </div>
          <br *ngIf="isMobile">
          <div class="leagueMenu">
            <a class="menuItem" href="{{baseURL}}/league/profile/{{rankemData?.league?.lg_abbr+'/'+rankemData?.league?.league_code}}">League Profile</a>
            <a class="menuItem" (click)="openLeague(rankemData?.league?.id,rankemData?.tournament_id)">Contest Details</a>
            <a class="menuItem active">My Team</a>
          </div>
        </div>
      </div>
  <div class="error" *ngIf="errors != ''">{{errors}}</div>
  <div class="success" *ngIf="successMsg != ''">{{successMsg}}</div>
  <div class="sectionHeaders" *ngIf="isMobile">
    <div class="sectionTitle" [ngClass]="{active:curTabClass == 'players'}" (click)="curTab='players';curTabClass='players'">
      <div class="titlePadding">{{rankemData.standing.length==0?'Players':'Standings'}}</div>
    </div>
     <div class="sectionTitle rankingTitle" matBadgeColor="warn" [matBadge]="selectedPlayers.length" matBadgePosition="above after"
      [matBadgeHidden]="(!selectedPlayers.length)" [ngClass]="{active:curTabClass == 'myteam'}"
      (click)="curTabClass=curTab='myteam';tabChange('0');">
      <div class="titlePadding">My Team</div>
    </div> 
   
  </div>
<div class="league-detail-content" appSameHeight className="sameHeight">
        <div class="left-section sameHeight" [ngClass]="{active:curTab == 'players'}">
                <div class="content-part">
                  <div class="filter-part" *ngIf="rankemData.standing.length==0">
                      <div class="searchContainer">
                              <mat-form-field>
                                <input type="text" placeholder="Search Player..." matInput [value]="searchString" (keyup)="setSearch($event)">
                                <i class="fas fa-search" style="color:var(--text-color)" *ngIf="searchString==''" matSuffix></i>
                                <i class="fas fa-times" style="cursor:pointer;color:var(--text-color)" *ngIf="searchString!=''" (click)="clearSearch()" matSuffix></i>
                              </mat-form-field>                                      
                              <div class="filter-left">
                                <mat-form-field>
                                        <mat-select placeholder="All Team" #teamfilter (selectionChange)="setSearch($event)" [(ngModel)]="team_filter">
                                                <mat-option *ngFor="let team of rankemData?.teams;index as t" [value]="team.abbr">{{team.loc}}</mat-option>
                                        </mat-select>
                                </mat-form-field>
                              </div>
                      </div>                     
                  </div>
                  <div class="filter-part" *ngIf="rankemData.standing.length!=0">
                    <div class="searchContainer">
                            <mat-form-field>
                              <input type="text" placeholder="Search..." matInput (keyup)="setSearch($event)">
                              <i class="fas fa-search" matSuffix></i>
                            </mat-form-field>
                    </div>                     
                </div>
                <div class="player-list" *ngIf="rankemData.standing.length==0"  [ngClass]="{'activeDraft':this.getClassName()}">
                  <div class="playersTable">
                          <div class="playersRemaining">
                            <span class="leftheading"><ng-container *ngIf="multiplier!=''"> Multiplier: {{rankemData?.ranked_player?.length - selectedPlayers.length > 2?rankemData?.ranked_player?.length - selectedPlayers.length - 2 +'x FPTS':'R'}}</ng-container></span> 
                            <span class="rightheading">Players Remaining: {{player_remainig}}</span></div>
                          <div class="playersHeaders">
                            <div class="pHeader posname" (click)="sortPlayers('pos')" [ngClass]="{'active':curSort == 'pos'}">
                              POS <i
                              *ngIf="curSort == 'pos'"
                              [ngClass]="{'fas':true,'fa-caret-up':curDir == 1,'fa-caret-down':curDir==-1}"></i></div>
                            <div class="pHeader pHeaderWide" (click)="sortPlayers('fn')"  [ngClass]="{'active':curSort == 'fn'}">
                              NAME <i
                              *ngIf="curSort == 'fn'"
                              [ngClass]="{'fas':true,'fa-caret-up':curDir == 1,'fa-caret-down':curDir==-1}"></i></div>
                            <div class="pHeader" [ngClass]="{'active':curSort == 'opn'}">
                              OPP <i></i></div>
                              <div class="pHeader" (click)="sortPlayers('fpts')" [ngClass]="{'active':curSort == 'fpts'}">
                                AVG <i
                                *ngIf="curSort == 'fpts'"
                                [ngClass]="{'fas':true,'fa-caret-up':curDir == 1,'fa-caret-down':curDir==-1}"></i></div>
                            <div class="pHeader" (click)="sortPlayers('proj')" [ngClass]="{'active':curSort == 'proj'}">
                              PROJ <i
                              *ngIf="curSort == 'proj'"
                              [ngClass]="{'fas':true,'fa-caret-up':curDir == 1,'fa-caret-down':curDir==-1}"></i></div>
                            <div class="pHeader addname"></div>
                          </div>
                          <div class="playersBody" [ngClass]="{'activeDraft':this.getClassName()}">
                            <ng-container *ngFor="let player of playerList | callback: filterPlayers">
                              <div class="pRow" *ngIf="playerDisplay(player)">
                            <div class="pValue posname" [ngStyle]="{'color':getPositionBG(player.pn)}">{{player.pn}}</div> 
                              <div class="pValue pValueWide playername"  (click)="openInfo(player,player.id,$event)">{{player.fn + ' ' + player.ln}} - <span class="pltn">{{player?.tn | uppercase}}</span>
                                <ng-container *ngIf="player.inj=='Y'">
                                  <span class="Tinjury"><strong data-toggle="tooltip" title="{{player.it}}" class="redfontColor"><div class="injuryBubble">{{player.inj_abbr}}</div></strong></span>
                                  
                                </ng-container>
                              </div>
                              <div class="pValue">{{player.tml!='home'?'@':''}}{{player.opn | uppercase}}</div>
                              <div class="pValue">{{player.gp>0?(player?.fpts/player.gp).toFixed(2):player?.fpts | number: '1.2-2'}}</div>
                              <div class="pValue">{{player?.prj | number: '1.2-2'}}</div>
                              <div class="pValue addname" *ngIf="player?.is_hide != 1 && player_remainig > 0" (click)="selectPlayer(player);"><i class="fas fa-plus-circle pAdd"></i></div>
                            </div>
                            </ng-container>
                          </div>
                  </div>
                </div>
                <div class="player-list" *ngIf="rankemData.standing.length!=0">
                  <div class="playersTable">
                          <div class="playersHeaders">
                            <div class="pHeader posname">
                              Rank</div>
                            <div class="pHeader pHeaderWide">
                              Team</div>
                            <div class="pHeader">
                              FPTS </div>
                            <div class="pHeader">
                              PMR</div>
                          </div>
                          <div class="playersBody" >
                            <ng-container *ngFor="let standing of rankemData.standing | callback: filterStandings">
                              <div class="pRow standing" [ngClass]="{'active':parameters.lgm_id==standing.lgm_id}" (click)="selectStanding(standing.lgm_id)">
                             <div class="pValue posname">{{standing.team_rank}}</div> 
                              <div class="pValue pValueWide">{{standing.team_name}}</div>
                              <div class="pValue">{{standing.team_total | number: '1.2-2'}}</div>
                              <div class="pValue">{{standing?.pmr | number: '1.2-2'}}</div>
                            </div>
                            </ng-container>
                          </div>
                        </div>
                 </div>
                </div>
        </div>
        <div class="right-section sameHeight" *ngIf="rankemData.ranked_player.length>0" [ngClass]="{active:curTab == 'myteam'}">
                <div class="heading"  style="min-height: 65px;">
                  <div style="display:inline-block;padding-left: 5px;"> {{rankemData?.team_name?rankemData?.team_name:'My Team'}}
                    <div class="fptsshow" style="display:inline-block" *ngIf="showfpts">({{rankemData.team_total | Price}} FPTS)</div>
                  </div> 
                 
                  <div class="rightheading">
                    <mat-form-field  [ngStyle]="{'display':rankemData.myTeams.length>0?'':'none'}">
                    <mat-select [(value)]="selectedteam" [placeholder]="showfpts?'Select A Team':'Create A Team'" class="form-control" id="teams" (selectionChange)="changeTeam($event)" >
                      <mat-option [value]="showfpts?'':'0'" [disabled]="showfpts">{{showfpts?'Select A Team':'Create A Team'}}</mat-option>
                        <mat-option *ngFor="let mt of rankemData.myTeams;index as index" [value]="mt.id" >Team {{index + 1}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                    <!-- <button mat-button class="joinBtn saveSection" style="display:none" (click)="showQuickJoin()">Dummy</button>
                    <button mat-button class="joinBtn saveSection" style="display:none" (click)="roasterFix()">Dummy</button> -->
                    <button  [ngStyle]="{'display':(rankemData.myTeams.length>0 || newTeam)?'':'none'}" mat-button class="joinBtn saveSection" (click)="joinLeaguePopup()" [disabled]="disableButton" [ngClass]="{'disabled':disableButton}">Submit</button>
                  </div>
                </div>
                <div class="content-part rankTable" [ngClass]="{'activeDraft':this.getClassName()}">
                        <div class="selected-rank playerRows">
                          <div class="tRow playerrow" *ngFor="let player of rankemData?.ranked_player;index as i;  ">
                            <span class="rank_text">
                              <span class="selectRank_{{player.pn}}">{{player.pn}}</span>
                              <span class="rank_textIn" [ngStyle]="{'color':darkMode==true?'':'#'+player.color}">{{player.pts_msg}}</span>
                            </span>
                            </div>
                        </div>
                        <div class="selected-players">
                                <div class="players-list">
                                                <div class="playerRows" [sortablejs]="selectedPlayers"
                                                [sortablejsOptions]="eventOptions" #playerrowele>
                                                  <div class="tRow playerrow team-{{player.tid}}-gradient"  [attr.data-player_id]="player.id" *ngFor="let player of selectedPlayers;index as i;" >
                                                      <div class="empSlotMain"  *ngIf="player?.id=='0'">
                                                        <div class="empSlot">{{player.pname}}</div>
                                                      </div>
                                                  <div [ngClass]="{'myTmDeta':(player.is_draggable || rankemData.standing.length=='0')}" *ngIf="player?.id!='0'">
                                                    <i *ngIf="player.is_draggable || rankemData.standing.length=='0'"  class="zmdi zmdi-menu drag_row"></i>
                                                  </div>
                                                    <div class="headshotCol" *ngIf="player?.plrImage!='' && !isMobile">
                                                      <div class="headshot" [ngStyle]="{'background-image':'url(\''+player.plrImage+'\')'}"></div>
                                                    </div>

                                                    <div class="playerCol playername" *ngIf="player?.id > 0" (click)="openInfo(player,player.id,$event)">
                                                      <div class="nameTop">
                                                        {{player.pname.split(' ')[0]}}
                                                      </div>
                                                      <div class="nameBottom">
                                                        {{getLastName(player)}}
                                                      </div>
                                                      {{player?.tn | uppercase}} {{player?.pick_rp}} | {{player.start_time}}

                                                    </div>
                                                    <div *ngIf="player?.id > 0" class="avgFormat1 statCol">
                                                      <span>AVG</span>
                                                      <br>
                                                      <span class="stat">{{player.avg | number: '1.2-2'}}</span>
                                                    </div>
                                                    <div class="statCol"  *ngIf="player?.id > 0">
                                                      <span>PROJ</span>
                                                      <br>
                                                      <div class="stat">
                                                        {{player.proj | number: '1.2-2'}}
                                                      </div>
                                                    </div>
                                                    <div class="deleteCol" *ngIf="player?.id >0  && showfpts==false" (click)="removePlayer(player,$event)">
                                                        <i class="fas fa-times"></i>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="playerRows">
                                                  <div class="tRow playerrow" *ngFor="let player of [].constructor(rankemData.ranked_player.length - selectedPlayers.length)">
                                                      <div class="empSlotMain">
                                                        <div class="empSlot">Select player</div>
                                                      </div>                                                   
                                                  </div>
                                                </div>
                                      
                                </div>
                        </div>
                </div>
        </div>
</div>

<div class="hideContent" *ngIf="visibleQuickJoin && quickContests.length" (click)="visibleQuickJoin = false;quickContests = [];"></div>
<ng-template #quickJoin>
<div class="quickjoin" [ngClass]="{'active':visibleQuickJoin && quickContests.length}">
  <div class="body">
    <h1>Stay in the Action!</h1>
    <h2>Check out these other contests with the same format!</h2>
    <div class="cardContainer">
      <div class="error" *ngIf="errors != ''">{{errors}}</div>
      <div class="success" *ngIf="successMsg != ''">{{successMsg}}</div>
      <div *ngFor="let contest of quickContests">
        <mat-card class="card">
          <mat-card-title class="cardTitle">
            {{contest.name}}
          </mat-card-title>
          <mat-card-subtitle class="sub">
            <div class="entries">
              <span class="current" *ngIf="contest.league_id == parameters.league_id">Current Contest<br></span>
              Entries: {{contest.joined_entrants}}/{{contest.entrants}}<br>
              Your Entries: {{contest.my_entries}}/{{contest.max_entries}}
            </div>
            <div class="actions">
              <button class="thisBtn" [disabled]="(contest.my_entries>=contest.max_entries)" [ngClass]="{'warn':contest.league_id == parameters.league_id}" mat-button (click)="quickJoinProcess(contest)">{{(contest.my_entries>=contest.max_entries)?'Joined':contest.confirm == 0?(contest.league_id == parameters.league_id?'Again':'Enter'):'Confirm?'}}</button>
              <button class="btn" mat-button (click)="redirect(contest)" *ngIf="contest.league_id == parameters.league_id">New</button>
            </div>
          </mat-card-subtitle>
          
        </mat-card>
      </div>
    </div>
  </div>
</div>
</ng-template>